<template>
  <div class="draws">
    <div v-if="dates && dates.length" ref="dateStripRef" class="date-strip">
      <div
        v-for="item in dates"
        :key="item.beginDate"
        class="date-strip-item"
        :class="{
          active: item.beginDate === activeDate,
          today: isStripToday(item.beginDate) && item.beginDate === activeDate
        }"
        @click="onSelectDate(item)"
      >
        {{ formatStripDate(item.beginDate) }}
        <span v-if="isStripToday(item.beginDate) && item.beginDate === activeDate">今</span>
      </div>
    </div>
    <div class="title">
      <div class="flex-center">
          <img src="https://images.snsports.cn/FuNfeXB9P4_L0ZqWMH3a8zp20UiJ" />
          直播中
      </div>
      <div class="flex-center">
          <img src="https://images.snsports.cn/Fh3ML18O7PE6NNcoMMnfM9h8m2_Y" />
          录像
      </div>
    </div>
    <div class="site-list">
      <div class="scroll-container">
        <div class="site-box">
          <div class="blank-card"></div>
          <div class="site-item" v-for="item in (siteList || [])" :key="item.id">
            <div class="site-title">{{ item.name }}</div>
          </div>
        </div>
        <div class="game-box">
          <div class="site-number">
            <div v-for="i in maxGameListLength" :key="i" class="site-number-item">
               <span>第</span><span>{{ i }}</span><span>场</span>
            </div>
          </div>
          <div class="site-item" v-for="item in (siteList || [])" :key="item.id">
            <div class="game-item" v-for="game in (item.gameList || [])" :key="game.id">
              <div
                class="game-item-time flex-center"
                :style="{ backgroundColor: getGameItemTimeBg(game) }"
              >
                <img
                  v-if="getGameStatus(game) === 'live'"
                  src="https://images.snsports.cn/FuNfeXB9P4_L0ZqWMH3a8zp20UiJ"
                  alt=""
                />
                <img
                  v-else-if="getGameStatus(game) === 'mp4'"
                  src="https://images.snsports.cn/Fh3ML18O7PE6NNcoMMnfM9h8m2_Y"
                  alt=""
                />
                <span v-if="game.beginDateMode === 0">{{ getFormatDate(game.beginDate, '{h}:{i}') || '开赛时间待定' }}</span>
                <span v-else-if="game.beginDateMode === 1">接上一场</span>
                <span v-else-if="game.beginDateMode === 2">不早于{{ getFormatDate(game.beginDate, '{h}:{i}') }}</span>
              </div>
              <div class="group flex-center">
                <div class="overflow-text">{{ game.group }}</div>
                <div class="overflow-text">
                  <span v-if="game.stageName">{{ game.stageName }}</span>
                  <span v-else-if="game.isGroupGame === 1">小组赛</span>
                  <span v-else>淘汰赛</span>&nbsp;<span v-if="game.round >= 0">第{{ game.round }}轮</span>
                  <span v-else>其他轮次</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="info flex-center">
                <div class="team overflow-text">{{ game.homeTeamName }}</div>
                <div class="score" v-if="game.homeScore > -1 && game.awayScore > -1">
                  <div v-if="game.unitType === 0"></div>
                  <div v-else>
                    <div class="score-team flex-center">
                      <div class="score-team-item" v-for="(score, si) in formatSubScores(game.subScore)" :key="si" :class="{ win: score.homeScore > score.awayScore }">{{ score.homeScore }}</div>
                    </div>
                    <div class="score-team flex-center" style="margin-top: 6px;">
                      <div class="score-team-item" v-for="(score, si) in formatSubScores(game.subScore)" :key="si" :class="{ win: score.awayScore > score.homeScore }">{{ score.awayScore }}</div>
                    </div>
                  </div>
                </div>
                <div class="score-text" v-else>{{ game.name || '未录入比分' }}</div>
                <div class="team overflow-text">{{ game.awayTeamName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUnionMatchFieldGameDateList, getUnionMatchFieldGameList } from '@/api/match-team-game'
import { getBMMatchList2 } from '@/api/match'
import ColorList from '@/utils/colorList'
import { DateUtil } from '@/utils'

export default {
  name: 'NewMatchDetailDraws',
  data() {
    return {
      unionMatchId: '',
      dates: [],
      activeDate: '',
      siteList: [],
      groupList: [],
      ColorList,
      mp4: 'https://images.snsports.cn/FuLkSv4qR0RynUd9u0wOq-9oA-dO', // 兜底：不依赖本地资源
      live: 'https://images.snsports.cn/FpZC7H9t4rYk2Lr5xJZ1_Rn8bJm1',
      completeImg: require('@/assets/images/success-icon.png'),
      isUnionMatchManager: false,
      gameBoxScrollTop: 0,
      siteListScrollLeft: 0
    }
  },
  computed: {
    /** siteList 各场地 gameList 条数最大值 */
    maxGameListLength() {
      if (!Array.isArray(this.siteList) || !this.siteList.length) return 0
      return Math.max(
        0,
        ...this.siteList.map((site) => (Array.isArray(site.gameList) ? site.gameList.length : 0))
      )
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    if (this.unionMatchId) {
      this.getUnionMatchFieldGameDateList()
      this.getBMMatchList2()
    }
    this.$nextTick(() => {
      const gameBox = this.$el.querySelector('.game-box')
      if (gameBox) gameBox.scrollTop = 0
      const siteList = this.$el.querySelector('.site-list')
      if (siteList) siteList.scrollLeft = 0
    })
  },
  activated() {
    this.$nextTick(() => {
      const gameBox = this.$el.querySelector('.game-box')
      if (gameBox) gameBox.scrollTop = this.gameBoxScrollTop || 0
      const siteList = this.$el.querySelector('.site-list')
      if (siteList) siteList.scrollLeft = this.siteListScrollLeft || 0
    })
  },
  methods: {
    goManage(game) {
      if (!this.isUnionMatchManager) return
      this.$router.push({ path: `/match-manage/scoring-console/${this.unionMatchId}`, query: { gameId: game.id } })
    },
    getGameStatus(game) {
      if (game.livePublic === 0) return ''
      if (game.liveStatus === 1) return 'live'
      if (game.liveStatus === 2) return 'mp4'
      return ''
    },
    /** game-item-time 条背景：直播中 / 录像 / 其他 */
    getGameItemTimeBg(game) {
      const s = this.getGameStatus(game)
      if (s === 'live') return '#CAEDB9'
      if (s === 'mp4') return '#BED5ED'
      return '#F9D6B6'
    },
    goDetail(item) {
      if ((item.awayScore > -1 && item.homeScore > -1) || this.getGameStatus(item) !== '') {
        this.$router.push(`/game/${item.id}/data`)
      }
    },
    getFormatDate(date, type = '{y}.{m}.{d} {h}:{i}') {
      return DateUtil.parseDateTime(date, type)
    },
    getColor(id, type) {
      const group = this.groupList.find((item) => item.id === id)
      if (!group) return {}
      if (type === 'date') {
        return { background: group.frontView }
      } else {
        return { background: group.backgroundColor }
      }
    },
    getUnionMatchFieldGameDateList() {
      getUnionMatchFieldGameDateList({ unionMatchId: this.unionMatchId }).then((res) => {
        const list = (res && res.data && res.data.list) || []
        this.dates = list
        this.activeDate = this.getNearestDate(list)
        this.getUnionMatchFieldGameList()
        this.$nextTick(() => this.scrollActiveDateIntoView())
      }).catch(() => {
        this.dates = []
        this.activeDate = ''
        this.siteList = []
      })
    },
    getBMMatchList2() {
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then((res) => {
        const list = (res && res.data && res.data.list) || []
        this.groupList = list.map((item, i) => {
          const color = this.ColorList[i % 8]
          item.frontView = color.frontView
          item.backgroundColor = color.backgroundColor
          return item
        })
      }).catch(() => {
        this.groupList = []
      })
    },
    getNearestDate(dateList) {
      if (!Array.isArray(dateList) || !dateList.length) return ''
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
      const todayDate = dateList.find((item) => {
        const itemDate = new Date(item.beginDate)
        const itemDateOnly = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate()).getTime()
        return itemDateOnly === today
      })
      if (todayDate) return todayDate.beginDate

      const nowTime = now.getTime()
      const dateMap = dateList.map((item) => {
        const timestamp = new Date(item.beginDate).getTime()
        return { ...item, timestamp, diff: timestamp - nowTime }
      })
      const futureDates = dateMap.filter((d) => d.diff > 0)
      const pastDates = dateMap.filter((d) => d.diff <= 0)

      if (futureDates.length > 0) {
        return futureDates.reduce((a, b) => (a.diff < b.diff ? a : b)).beginDate
      }
      if (pastDates.length > 0) {
        return pastDates.reduce((a, b) => (Math.abs(a.diff) < Math.abs(b.diff) ? a : b)).beginDate
      }
      return null
    },
    getUnionMatchFieldGameList() {
      getUnionMatchFieldGameList({ unionMatchId: this.unionMatchId, date: this.activeDate }).then((res) => {
        const data = (res && res.data) || {}
        this.isUnionMatchManager = !!data.isUnionMatchManager
        this.siteList = (data.list || []).map((site) => ({
          ...site,
          gameList: Array.isArray(site.gameList) ? site.gameList : []
        }))
      }).catch(() => {
        this.siteList = []
      })
    },
    /** 赛程日期条：M.dd */
    formatStripDate(beginDate) {
      const d = new Date(beginDate)
      if (Number.isNaN(d.getTime())) return ''
      const m = d.getMonth() + 1
      const day = d.getDate()
      return `${m}.${String(day).padStart(2, '0')}`
    },
    stripDayKey(dateStr) {
      const d = new Date(dateStr)
      if (Number.isNaN(d.getTime())) return ''
      return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
    },
    isStripToday(beginDate) {
      const now = new Date()
      const t = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`
      return this.stripDayKey(beginDate) === t
    },
    onSelectDate(item) {
      if (!item || item.beginDate === this.activeDate) return
      this.activeDate = item.beginDate
      this.getUnionMatchFieldGameList()
      this.$nextTick(() => this.scrollActiveDateIntoView())
    },
    scrollActiveDateIntoView() {
      const root = this.$refs.dateStripRef
      if (!root || typeof root.querySelector !== 'function') return
      const el = root.querySelector('.date-strip-item.active')
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' })
      }
    },
    formatSubScores(subScore) {
      if (!subScore) return []
      return subScore
        .split(',')
        .map((score) => {
          const [homeScore, awayScore] = score.split(':').map(Number)
          if (homeScore === -1 || awayScore === -1) return null
          return { homeScore, awayScore }
        })
        .filter(Boolean)
    }
  },
  beforeRouteLeave(to, from, next) {
    const gameBox = this.$el.querySelector('.game-box')
    if (gameBox) this.gameBoxScrollTop = gameBox.scrollTop
    const siteList = this.$el.querySelector('.site-list')
    if (siteList) this.siteListScrollLeft = siteList.scrollLeft
    next()
  }
}
</script>

<style scoped lang="scss">
.draws {
  // padding: 8px;
  color: #4D4D4D;
  min-height: 100vh;
  background: #EEEEF1;
  .date-strip {
    padding-left: 16px;
    display: flex;
    align-items: center;
    height: 44px;
    background: #FFFFFF;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    -ms-overflow-style: none;
    .date-strip-item {
      &:not(:last-child) {
        margin-right: 10px;
      }
      padding: 0 9px;
      position: relative;
      height: 38px;
      // width: 74px;
      min-width: 74px;
      line-height: 38px;
      text-align: center;
      border-radius: 3px;
      font-size: 14px;
      font-weight: 500;
      box-sizing: border-box;
      color: #303133;
      &::after {
        content: '';
        position: absolute;
        display: inline-block;
        width: 1px;
        height: 16px;
        background: #EEEEEE;
        top: 50%;
        right: -5px;
        transform: translateY(-50%);
      }
      &.active {
        background: #337ECC;
        color: #FFFFFF;
      }
      &.today{
        min-width: 90px !important;
      }
      span{
        display: inline-block;
        width: 21px;
        height: 21px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.2);
        color: #FFFFFF;
        text-align: center;
        line-height: 21px;
        margin-left: 8px;
      }
    }
  }

  .title {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #73767A;
    > * + * {
      margin-left: 28px;
    }
    img {
      width: 18px;
      height: 18px;
      margin-right: 7px;
    }
  }

  .site-list {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    padding-left: 1px;

    > div.scroll-container {
      display: inline-block;
      min-width: 100%;

      .site-box {
        display: flex;
        .blank-card{
          width: 24px;
          height: 44px;
          border-radius: 3px;
          background: #FFFFFF;
          margin-right: 6px;
        }

        .site-item {
          margin-right: 6px;

          .site-title {
            text-align: center;
            width: 120px;
            height: 44px;
            line-height: 44px;
            border-radius: 3px;
            background: #FFFFFF;
            font-size: 12px;
            font-weight: 500;
            color: #303133;
          }
        }
      }

      .game-box {
        height: calc(100vh - 140px - 12px);
        display: flex;
        overflow-y: auto;
        white-space: normal;
        margin-top: 6px;
        .site-number{
          width: 24px;
          .site-number-item{
            width: 24px;
            height: 200px;
            border-radius: 3px;
            background: #748598;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
             display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 6px;
          }
        }
        .game-item{
          width: 120px;
          height: 200px;
          border-radius: 5px;
          background: #FFFFFF;
          margin-left: 6px;
          margin-bottom: 6px;
          overflow: hidden;
          .game-item-time{
            font-size: 13px;
            font-weight: 600;
            height: 30px;
            color: #303133;
            justify-content: center;
            img{
              width: 18px;
              height: 18px;
              margin-right: 4px;
            }
          }
          .group{
            text-align: center;
            height: 50px;
            font-size: 13px;
            font-weight: 500;
            color: #303133;
            flex-direction: column;
            justify-content: center;
          }
          .line{
            height: 1px;
            background: #EEEEEE;
            margin-top: 3px;
          }
          .info{
            height: 117px;
            padding: 0 12px;
            flex-direction: column;
            justify-content: center;
            > * + * {
              margin-top: 6px;
            }
            .team{
              font-size: 12px;
              color: #4D4D4D;
              text-align: center;
            }
            .score{
              .score-team{
                justify-content: center;
                > * + * {
                  margin-left: 2px;
                }
                .score-team-item{
                  width: 20px;
                  height: 20px;
                  border-radius: 3px;
                  background: #E9E9EB;
                  font-size: 14px;
                  font-weight: bold;
                  color: #909399;
                  text-align: center;
                  line-height: 20px;
                  &.win{
                    background: #ECF5FF;
                    color: #337ECC;
                  }
                }
              }
            }
            .score-text{
              font-size: 14px;
              color: #4D4D4D;
              text-align: center;
            }
          }
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;
  }
}

.vs {
  .sub-score {
    display: flex;
    margin: 4px 0;

    > div:not(:last-child) {
      margin-right: 4px;
    }
    justify-content: center;

    > div {
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #D8D8D8;
      border-radius: 2px;
      font-size: 15px;
      font-weight: 500;
      color: #8D8D8D;

      &.win {
        color: #4D4D4D;
        background: #C2E5E3;
      }
    }
  }
}
</style>

